import '../../resources/css/visual/VisualPage.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { checkTableAuth } from '../../components/common/access-auth';
import { forwardLogin, doGetCompleteTutorialData } from '../../actions/login/index';
import VisualMonitor from '../../components/visual/VisualMonitor';
// import ModalConfirm from '../../components/common/ModalConfirm';
import ModalPickGroup from '../../components/picker/ModalPickGroup';
import ModalPickDeviceList from '../../components/picker/ModalPickDeviceList';
import Loading from '../../components/common/Loading';
import { doActivePage } from '../../actions/menu/index';
import Joyride, { STATUS } from 'react-joyride';


const tutorialStyles = {
  options: {
    primaryColor: '#0084dd',
    arrowColor: 'white',
    textColor: 'white',
    overlayColor: 'rgba(0, 0, 0, .8)',
    zIndex: 9999,
  },
  spotlight: {
    position: 'fixed',
    borderRadius: '10px',
    outline: 'dashed white 2px',
    outlineOffset: '8px',
  },
  tooltipTitle: {
    color: 'white'
  },
  tooltip: {
    borderRadius: '10px',
    backgroundColor: 'none',
    border: 'solid',
    borderColor: 'white',
    pointerEvents: 'initial',
  },
  buttonBack: {
    color: 'white',
  },
  buttonNext: {
    color: '#595959',
    backgroundColor: 'none',
  },
  buttonClose: {
    display: 'none',
  },
}
// const tutorialStepsInitial = [
//   {
//     title: "Add floor plan",
//     target: ".area-initial-body .add-rf-map-btn",
//     content: "Add floor plan on this project",
//     disableBeacon: true,
//     locale: {
//       close: "Close",
//     },
//     disableOverlayClose: true,
//   }
// ]
const tutorialSteps = [
  {
    title: "Floor Plan Manager Settings",
    target: ".area-filter .icon-settings",
    content: "Click this setting icon to view Floor Plan Manager List and to view info, edit or delete detail",
    disableBeacon: true,
    locale: {
      skip: "Skip",
      // back: "Back",
      next: "Next",
      close: "Close",
    },
    disableOverlayClose: true,
  },
  {
    title: "Add device",
    target: ".area-add-icon",
    content: "Add device on the map by selecting device",
    disableBeacon: true,
    locale: {
      skip: "Skip",
      back: "Back",
      next: "Next",
      close: "Close",
    },
    disableOverlayClose: true,
    placement: 'left-start',
  },
  {
    title: "Wi-Fi Coverage",
    target: ".icon-btn-wifi-coverage-n",
    content: "View wi-fi coverage by selecting heatmap mode, wi-fi band, and resolution level",
    disableBeacon: true,
    locale: {
      skip: "Skip",
      back: "Back",
      next: "Next",
      close: "Close",
    },
    disableOverlayClose: true,
  },
  {
    title: "Wall Material",
    target: ".icon-btn-brick-n",
    content: "Select wall material for line drawing",
    disableBeacon: true,
    locale: {
      skip: "Skip",
      back: "Back",
      next: "Next",
      close: "Close",
    },
    disableOverlayClose: true,
  }, 
  {
    title: "Scale Setting",
    target: ".icon-btn-scale-n",
    content: "Draw a line and then enter the length it represents",
    disableBeacon: true,
    locale: {
      back: "Back",
      close: "Close",
    },
    disableOverlayClose: true,
  }
]


class VisualPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      pageSize : 10,
      tabulatorDivHeight: 0,
      tutorialRun: false  
    }
  }

  timerSlideRule = null;



  componentDidMount () {
    const { forwardLogin, accountRole, roleTableAuth, history, doActivePage } = this.props;
    if (checkTableAuth('rf_map', accountRole, roleTableAuth, 1)) {
      // temp
      doActivePage('rf_map/floorplan');
    } else {
      forwardLogin("Sorry yon can't access this page.");
      history.push(window.CONFIG.WEB_ROOT + "/Login");
    }
  }

  handleTutorialCallback = data => {
    const { index, status, size } = data;
    const { doGetCompleteTutorialData, authToken } = this.props;
    const { tutorialRun } = this.state;

    if (((index === size - 1) && (status === STATUS.FINISHED)) || status === STATUS.SKIPPED) {
      if(tutorialRun) {
        this.setState({tutorialRun: false});
      } else {
        doGetCompleteTutorialData(authToken, 7);
      }
    }
  };

  render() {
    const { interiorGraphImgUrl, accountInfoTutorial } = this.props;
    const { tutorialRun } = this.state;
    // const showRuler = displayBlueprint && adjustCoefficientTargetDevice && adjustCoefficientTargetDevice !== 'Device'
    // const [value, setValue] = useState(150);

    let monitor, filterContent;
    let pageContent = <Loading loading={false}></Loading>;
    let modalDetailContent = <div className='modal-detail-empty'></div>;
    filterContent = <div className='area-filter'></div>;
    
    
    pageContent = <VisualMonitor></VisualMonitor>;
    

    monitor = (
      <div className='area-visual'>
        <div className='area-title-bar'>
          <span className='title'>Floor Plan</span>
          <div className='area-page-header-btn'>
            <span className='area-icon-btn'><span id="visual-page-tutorial" className='icon-btn-tutorial icon-btn' onClick={() => this.setState({tutorialRun: true})} title='tutorial' /></span>
          </div>
        </div>
        <div className="line"></div>
        
        <div className='area-filter-bar' ref={ (filterDiv) => { this.filterDiv = filterDiv } }>
          { filterContent }
        </div>
        <div className='area-page-content'>
          {pageContent}
        </div>
        <div className='area-modal-datail'>
          { modalDetailContent }
        </div>
        <Joyride
            callback={this.handleTutorialCallback}
            run={(interiorGraphImgUrl && accountInfoTutorial) || tutorialRun }
            steps={tutorialSteps}
            styles={tutorialStyles}
            showProgress
            showSkipButton
            continuous={true}
            scrollToSteps={true}
          /> 
      {/*<ModalConfirm></ModalConfirm>*/}
      <ModalPickGroup selectMultiCol={true}></ModalPickGroup>
      <ModalPickDeviceList></ModalPickDeviceList>
    </div>
    );

    return (
      <div className='area-visual-page area-page'>
        {monitor}
      </div>
    );    
  }
}

const mapStateToProps = (state, ownProps) => {
  // const { subPage } = ownProps.match.params;
  const completeTutorial = !state.loginReducers?.accountInfo?.completeTutorial?.split(',').find(e => e === '7');

  return {
    authToken: state.loginReducers.authToken,
    accountRole: state.loginReducers.accountRole,
    accountInfo: state.loginReducers.accountInfo,
    roleTableAuth: state.loginReducers.roleTableAuth,
    // subPage: subPage,
    accountInfoTutorial: completeTutorial,
    interiorGraphImgUrl: state.visualReducers.interiorGraphImgUrl,
    mappingInteriorGraph: state.visualReducers.mappingInteriorGraph,
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { doActivePage, forwardLogin, doGetCompleteTutorialData }
)(VisualPage))
